<template>
  <button v-if="!link" :class="mode">
    <slot></slot>
  </button>
  <router-link v-else :to="to" class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: ''
      },
      link: {
        type: Boolean,
        required: false,
        default: false,
      },
      to: {
        type: String,
        required: false,
        default: '/'
      },
    }
  }
</script>

<style scoped>
  button,
  a {
    text-decoration: none;
    padding: 0.65rem 1.5rem;
    font: inherit;
    background-color: #3a0061;
    border: 1px solid #3a0061;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    margin-right: 0.5rem;
    display: inline-block;
  }

  a:hover,
  a:active,
  button:hover,
  button:active {
    background-color: #270041;
    border-color: #270041;
  }

  .flat {
    background-color: transparent;
    color: #3a0061;
    border: none;
  }

  .outline {
    background-color: transparent;
    border-color: #005b96;
    color: #1ea1f7;
  }

    .flat:hover,
    .flat:active,
    .outline:hover,
    .outline:active {
      background-color: #1ea1f7;
      color: #ffffff;
      border-color: #005b96;
    }
</style>

